import toast, { type ToastOptions as ReactHotToastOptions } from 'react-hot-toast'

type ToastType = 'success' | 'error'

type ToastOptions = Pick<
  ReactHotToastOptions,
  'duration' | 'position' | 'icon' | 'className' | 'style' | 'ariaProps' | 'iconTheme'
>

export const showToast = (type: ToastType, message: string, options?: ToastOptions) => {
  toast[type](message, options)
}
